export const resolve = (input) => {
  if (input == null) {
    return null;
  }
  return {
    ...input,
  };
};
